import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";


const initialState = {
    value: false
}

export const displayLoading = createSlice({
    name: "displayLoading",
    initialState,
    reducers: {
        setIsLoadingTrue: state => {
            state.value = true
        },
        setIsLoadingFalse: state => {
            state.value = false
        }
    }

})

export const {setIsLoadingTrue, setIsLoadingFalse} = displayLoading.actions
export default displayLoading.reducer
export const selectLoadingValue = (state: RootState) => state.displayLoading.value